import { _converse, api, u, constants, Model } from '@converse/headless';
import { CustomElement } from 'shared/components/element.js';
import { MOBILE_CUTOFF } from 'shared/constants.js';
import DragResizable from 'plugins/dragresize/mixin.js';
import tplControlbox from './templates/controlbox.js';
import './navbar.js';

const { LOGOUT } = constants;

/**
 * The ControlBox is the section of the chat that contains the open groupchats,
 * bookmarks and roster.
 *
 * In `overlayed` `view_mode` it's a box like the chat boxes, in `fullscreen`
 * `view_mode` it's a left-aligned sidebar.
 */
class ControlBoxView extends DragResizable(CustomElement) {
    initialize() {
        this.setModel();
        async function clearStaleFilter(model) {
    // Чекаємо, поки Converse закінчить всі маніпуляції з базою (IndexedDB)
    await api.waitUntil('chatBoxesFetched');
    
    if (model.get('filter_text') !== '') {
        console.log(`[Sonata UI] Found stale filter in IndexedDB: "${model.get('filter_text')}". Cleaning...`);
        
        // safeSave — це обгортка Converse, яка гарантовано записує дані в IndexedDB
        u.safeSave(model, {
            'filter_text': '',
            'search_text': ''
        });

        // Якщо це в'юха, просимо її перемалюватися
        if (typeof model.trigger === 'function') {
            model.trigger('change'); 
        }
    }
}

// Викликаємо функцію
clearStaleFilter(this.model);
        const { chatboxviews } = _converse.state;
        chatboxviews.add('controlbox', this);
        if (this.model.get('connected') && this.model.get('closed') === undefined) {
            this.model.set('closed', !api.settings.get('show_controlbox_by_default'));
        }
        this.viewportMediaQuery = window.matchMedia(`(max-width: ${MOBILE_CUTOFF}px)`);
        this.renderOnViewportChange = () => this.requestUpdate();
        /**
         * Triggered when the _converse.ControlBoxView has been initialized and therefore
         * exists. The controlbox contains the login and register forms when the user is
         * logged out and a list of the user's contacts and group chats when logged in.
         * @event _converse#controlBoxInitialized
         * @type {ControlBoxView}
         * @example _converse.api.listen.on('controlBoxInitialized', view => { ... });
         */
        api.trigger('controlBoxInitialized', this);
    }


    /** @param {MouseEvent} ev */
        showAddContactModal(ev) {
            api.modal.show('converse-add-contact-modal', { model: new Model() }, ev);
        }

    connectedCallback() {
        super.connectedCallback();
        this.viewportMediaQuery.addEventListener('change', this.renderOnViewportChange);
    }

    disconnectedCallback() {
        super.disconnectedCallback();
        _converse.state.chatboxviews.remove('controlbox', this);
        this.viewportMediaQuery.removeEventListener('change', this.renderOnViewportChange);
    }

    setModel() {
        this.model = _converse.state.chatboxes.get('controlbox');
        this.listenTo(_converse.state.connfeedback, 'change:connection_status', () => this.requestUpdate());
        this.listenTo(this.model, 'change:active-form', () => this.requestUpdate());
        this.listenTo(this.model, 'change:connected', () => this.requestUpdate());
        // Re-render so the chat list can highlight whichever chat is currently
        // open (see isCurrentlyOpen() in templates/controlbox.js) as soon as
        // the user switches chats.
        this.listenTo(_converse.state.chatboxes, 'change:hidden', () => this.requestUpdate());
        this.requestUpdate();
    }

    render() {
        if (api.settings.get('view_mode') === 'overlayed') {
            return this.model && !this.model.get('closed') ? tplControlbox(this) : '';
        }
        return tplControlbox(this);
    }

    close(ev) {
        ev?.preventDefault?.();
        const connection = api.connection.get();
        if (
            ev?.name === 'closeAllChatBoxes' &&
            (connection.disconnection_cause !== LOGOUT || api.settings.get('show_controlbox_by_default'))
        ) {
            return;
        }
        if (api.settings.get('sticky_controlbox') || api.settings.get('view_mode') !== 'overlayed') {
            return;
        }
        u.safeSave(this.model, { closed: true });
        api.trigger('controlBoxClosed', this);
        return this;
    }
}

api.elements.define('converse-controlbox', ControlBoxView);

export default ControlBoxView;
